module.exports = __webpack_public_path__ + "static/img/title.69ec347.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/tell_tex/title.jpg
// module id = 455
// module chunks = 1